"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _models = _interopRequireDefault(require("../utils/models"));

var _lodash = _interopRequireDefault(require("lodash"));

/**
 * Custom Redux Model
 * @param {Object}
 * @constructor
 */
var Model = function Model(_ref) {
  var modelName = _ref.modelName,
      _ref$actionCreators = _ref.actionCreators,
      actionCreators = _ref$actionCreators === void 0 ? {} : _ref$actionCreators,
      _ref$selectors = _ref.selectors,
      selectors = _ref$selectors === void 0 ? {} : _ref$selectors,
      _ref$initialState = _ref.initialState,
      initialState = _ref$initialState === void 0 ? {} : _ref$initialState,
      namespace = _ref.namespace;
  (0, _classCallCheck2.default)(this, Model);
  return (0, _models.default)({
    modelName: modelName,
    initialState: _lodash.default.merge({}, Model.initialState, initialState),
    selectors: selectors,
    actionCreators: actionCreators,
    namespace: namespace
  });
};

exports.default = Model;
(0, _defineProperty2.default)(Model, "initialState", {});